import {
	CheckboxField,
	CreateDrawerFormProps,
	DateField,
	FormDrawer,
	FormDrawerContent,
	FormDrawerContentProps,
	FormFetchDrawer,
	UpdateDrawerFormProps,
} from "@dgs/core";
import { BranchOptionDto } from "apiGen";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { BranchSelectField } from "~root/branches/BranchSelectField";
import { offDayService } from "~shared/api/off_day/off_day_service";

export type IOffDayFormState = {
	date: string;
	halfDay: boolean;
	branch: BranchOptionDto | null;
};

const useValidate = () => {
	const { t } = useTranslation();

	return (values: IOffDayFormState) => {
		const errors: { [K in keyof IOffDayFormState]?: any } = {};

		if (!values.date) {
			errors.date = t("Field is required");
		}
		if (!values.branch) {
			errors.branch = t("Field is required");
		}

		return errors;
	};
};

const OffDayDrawerContent: FC<FormDrawerContentProps> = (props) => {
	const { t } = useTranslation();

	return (
		<FormDrawerContent {...props}>
			<DateField name="date" label={t("Date")} required />
			<CheckboxField name="halfDay" label={t("Half day")} />
			<BranchSelectField name="branch" label={t("Branch")} />
		</FormDrawerContent>
	);
};

const initialValues: IOffDayFormState = {
	date: "",
	branch: null,
	halfDay: false,
};

export const OffDayDrawerCreateDrawer: FC<CreateDrawerFormProps<IOffDayFormState>> = (drawerProps) => {
	const { t } = useTranslation();
	const validate = useValidate();

	return (
		<FormDrawer
			{...drawerProps}
			title={t("Add off day")}
			validate={validate}
			initialValues={initialValues}
			renderForm={(props) => <OffDayDrawerContent {...props} />}
		/>
	);
};

export const OffDayUpdateDrawer: FC<UpdateDrawerFormProps<IOffDayFormState>> = (drawerProps) => {
	const { t } = useTranslation();
	const validate = useValidate();

	return (
		<FormFetchDrawer
			{...drawerProps}
			queryFn={() => offDayService.show(+drawerProps.id).then((x) => x.data.data)}
			queryKey={offDayService.showKey(drawerProps.id)}
			title={t("Edit off day")}
			validate={validate}
			renderSuccess={(props) => <OffDayDrawerContent {...props} />}
		/>
	);
};
